<template>
  <button
    @click="toggleMute"
    :class="[$style.container, {[$style.muted]: isRepMuted}]"
    :disabled="callStatus !== 'in-progress'"
    :title="tooltip"
    v-tippy><font-awesome-icon :icon="icon" /></button>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faMicrophone } from '@fortawesome/pro-light-svg-icons/faMicrophone'
  import { faMicrophoneSlash } from '@fortawesome/pro-light-svg-icons/faMicrophoneSlash'
  import { createNamespacedHelpers } from 'vuex'
  import EventBus from '@/lib/event-bus'

  const { mapState, mapGetters } = createNamespacedHelpers('conference')

  export default {
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
        faMicrophone,
        faMicrophoneSlash
      }
    },
    computed: {
      ...mapState([
        'isRepMuted'
      ]),
      ...mapGetters([
        'callStatus'
      ]),
      icon () {
        return this.isRepMuted
          ? this.faMicrophoneSlash
          : this.faMicrophone
      },
      tooltip () {
        return this.isRepMuted
          ? 'Unmute'
          : 'Mute'
      }
    },
    methods: {
      toggleMute () {
        EventBus.$emit('TOGGLE_MUTE')
      }
    }
  }
</script>

<style module lang="less" src="./mute-toggle-button.less"></style>



// WEBPACK FOOTER //
// mute-toggle-button.vue?e5c03e96